/* eslint-disable */
import Minute from "../../components/Minute/Minute";
import "./Home.css";
import Media from "../../components/Media/Media";
import { DivMinuteEnum, DivChartEnum, SelectTypeGridEnum } from '../../../utils/enums';
import Analytic from "../../components/Analytic/Analytic";
import MediaComp from "../../components/MediaComp/MediaComp";

export function validUserInstance(user: any, auth): boolean {
  return user?.userPreference !== undefined && auth?.username !== undefined;
}

export function getTypeGrid(DivChart, DivMinute, shouldSave = false): number {
  let selectTypeGrid = 5; //5-none

  if ((DivChart < DivChartEnum.Analytic) && DivMinute === DivMinuteEnum.Image) {
    selectTypeGrid = 3; //3:image

  } else if (DivChart === DivChartEnum.Chart && DivMinute === DivMinuteEnum.Minute) {
    selectTypeGrid = 0; // 0:both

  } else if (DivChart === DivChartEnum.Empty && DivMinute === DivMinuteEnum.Empty) {
    selectTypeGrid = 2; //2:Minute-Empty

  } else if (DivChart > DivChartEnum.Chart && (DivMinute === DivMinuteEnum.Minute || DivMinute === DivMinuteEnum.Image)) {
    selectTypeGrid = 1; //1:Minute-MedComp

  } else if (DivChart === DivChartEnum.Chart && DivMinute > DivMinuteEnum.Minute && DivMinute !== DivMinuteEnum.Analytic) {
    selectTypeGrid = 4; //4:Media

  } else if (DivChart === DivChartEnum.Empty && DivMinute === DivMinuteEnum.Media) {
    selectTypeGrid = 6; //6:Media-Empty

  } else if (DivMinute === DivMinuteEnum.Analytic) {
    selectTypeGrid = 7; //7:Analytic
  }

  if (!shouldSave) {
    localStorage.setItem("selectTypeGrid", selectTypeGrid.toString());
    
    if (selectTypeGrid === 3 || selectTypeGrid === 7) {
      const screenValue = selectTypeGrid === 3 ? "selectTypeGridImageChart" : "selectTypeGridAnalyticChart";
      localStorage.setItem(screenValue, DivChart.toString());
      
      const userPreference = JSON.parse(localStorage.getItem('userPreference') || '{}');
      if (userPreference && Object.keys(userPreference).length > 0) {
        userPreference.selectTypeGrid = selectTypeGrid;
        userPreference[screenValue] = DivChart;
        localStorage.setItem('userPreference', JSON.stringify(userPreference));
      }
    } else {
      const userPreference = JSON.parse(localStorage.getItem('userPreference') || '{}');
      if (userPreference && Object.keys(userPreference).length > 0) {
        userPreference.selectTypeGrid = selectTypeGrid;
        localStorage.setItem('userPreference', JSON.stringify(userPreference));
      }
    }
  }
  return selectTypeGrid;
}

export function getSelectedTypeGrid(selectTypeGrid: number): { DivChart: number, DivMinute: number } {
  if (selectTypeGrid === 3 || selectTypeGrid === 7) {
    const screen = selectTypeGrid === 3 ? "selectTypeGridImageChart" : "selectTypeGridAnalyticChart";
    
    const defaultDivChart = selectTypeGrid === 3 ? DivChartEnum.Image : DivChartEnum.Empty;
    const DivMinute = selectTypeGrid === 3 ? DivMinuteEnum.Image : DivMinuteEnum.Analytic;

    const savedDivChart = localStorage.getItem(screen);
    const DivChart = savedDivChart ? parseInt(savedDivChart) : defaultDivChart;
    return { DivChart, DivMinute };
  }
 
  switch (selectTypeGrid) {
    case 0: // both
      return { DivChart: DivChartEnum.Chart, DivMinute: DivMinuteEnum.Minute };

    case 1: // minute-MedComp
      return { DivChart: DivChartEnum.MedComp, DivMinute: DivMinuteEnum.Minute };

    case 2: // minute-empty
      return { DivChart: DivChartEnum.Empty, DivMinute: DivMinuteEnum.Minute };

    case 3: // image
      return { DivChart: DivChartEnum.Image, DivMinute: DivMinuteEnum.Image };

    case 4: // media
      return { DivChart: DivChartEnum.Chart, DivMinute: DivMinuteEnum.Media };

    case 5: // media-MedComp
      return { DivChart: DivChartEnum.MedComp, DivMinute: DivMinuteEnum.Media };

    case 6: // empty-media
      return { DivChart: DivChartEnum.Empty, DivMinute: DivMinuteEnum.Media };

    case 7: // analytic
      return { DivChart: DivChartEnum.Empty, DivMinute: DivMinuteEnum.Analytic };

    default: // 5-none ou outros valores
      return { DivChart: DivChartEnum.Chart, DivMinute: DivMinuteEnum.Minute };
  }
}

export function renderDivMedComp(DivChart: number, DivMinute: number, hasShortHeight: boolean) {

  return DivChart === DivChartEnum.MedComp && !hasShortHeight ? (
    <div id="DivMedComp" data-testid="DivMedComp" style={{ paddingBottom: "17px", marginTop: "-10px" }}>
      <MediaComp />
    </div>
  ) : (
    <></>
  );

}

export function getClassSelecGrid(sidebar: string): string {
  return sidebar === "selecGrid" ? "selec-menu" : "selec-menu-hidden";
}

export function getClassSelecGraphButton(
  divValueSelected: number,
  valueCondition: number
): string {
  return divValueSelected === valueCondition ? "btn_selec_on" : "btn_selec_off";
}

export function renderDivMinuteChart(
  selectTypeGrid: number,
  SelectGrid,
  changeSelectDiv,
  DivMinute,
  DivChart,
  hasShortHeight) {

  return selectTypeGrid === SelectTypeGridEnum.Minute ||
    selectTypeGrid === SelectTypeGridEnum.Both ||
    selectTypeGrid === SelectTypeGridEnum.Empty ||
    selectTypeGrid === SelectTypeGridEnum.Image && !hasShortHeight ? (
    <div id="DivMinuteChart" data-testid="DivMinuteChart">
      <Minute onSelectGrid={SelectGrid} selectTypeGrid={selectTypeGrid} changeSelectDiv={changeSelectDiv} DivMinute={DivMinute} DivChart={DivChart} />
    </div>
  ) : (
    <></>
  );
}

export function renderDivTelaMedia(
  DivMinute: number,
  selectTypeGrid: number,
  SelectGrid,
  DivChart,
) {
  return DivMinute === DivMinuteEnum.Media ? (
    <div
      id="DivTelaMedia"
      data-testid="DivTelaMedia"
    >
      <Media onSelectGrid={SelectGrid} selectTypeGrid={selectTypeGrid} DivMinute={DivMinute} DivChart={DivChart} />
    </div>
  ) : (
    <></>
  );
}

export function renderDivAnalytic(selectTypeGrid: number, changeSelectDiv) {
  return selectTypeGrid === SelectTypeGridEnum.Analytic ? (
    <div
      id="divAnalytic"
      data-testid="divAnalytic"
      style={{ position: "absolute" }}
    >
      <Analytic selectTypeGrid={selectTypeGrid} changeSelectDiv={changeSelectDiv} />
    </div>
  ) : (
    <></>
  );
}
export function controlNavBarAux(component: string, sidebar, setSidebar, blurPanel) {
  component !== sidebar ? setSidebar(component) : setSidebar("");
  blurPanel.setBlur(false);
}

export function SelectGridAux(setSidebar) {
  setSidebar("selecGrid");
}

export function changeSelectDivAux(typeSelec, valSelect, setDivChart, setDivMinute, divMinute = 0) {
  if (typeSelec === "C") {
    setDivChart(valSelect);

  } else {
    setDivMinute(valSelect);
  }
}